import { useEffect } from 'react'
import { ErrorEnum } from '@/utils/announcements'
import {useAnnouncementsContext} from "@/contexts/AnnouncementsContext";

const useInternetConnection = (): void => {
  const { addAnnouncement, removeAnnouncement } = useAnnouncementsContext()

  useEffect(() => {
    const handleConnectionChange = () => {
      if (navigator.onLine) {
        removeAnnouncement(ErrorEnum.NO_INTERNET_CONNECTION)
      } else {
        addAnnouncement(ErrorEnum.NO_INTERNET_CONNECTION)
      }
    }

    handleConnectionChange()
    window.addEventListener('online', handleConnectionChange)
    window.addEventListener('offline', handleConnectionChange)

    return () => {
      window.removeEventListener('online', handleConnectionChange)
      window.removeEventListener('offline', handleConnectionChange)
    }
  }, [])
}

export default useInternetConnection
